export const data = {
  hair: [
    {
      id: '1',
      name: 'SERIE EXPERT ABSOLUT REPAIR Шампунь для восстановления поврежденных волос',
      desc: 'Шампунь мягко очищает поврежденные волосы, не пересушивая их в процессе мытья.',
      image: 'https://static.iledebeaute.ru/files/images/tag/part_19/386209/pre/500_500sb.jpg',
      price: 1300,
      category: 2,
    },
    {
      id: '2',
      name: 'HASK Argan Oil Дуо-набор для восстановления волос',
      desc: 'Восстанавливающий шампунь для волос с Аргановым маслом проникает в структуру волоса и восстанавливает его изнутри.',
      image: 'https://static.iledebeaute.ru/files/images/tag/part_13/263672/pre/500_500sb.jpg',
      price: 1460,
      category: 2,
    },
    {
      id: '3',
      name: 'SOL DE JANEIRO  BRAZILIAN JOIA Кондиционер Сила и гладкость',
      desc: 'Поддержите силу своих прядей с помощью действия hug + treat, чтобы "склеить" вместе секущиеся кончики, уменьшить ломкость и помочь предотвратить повреждения.',
      image: 'https://static.iledebeaute.ru/files/images/tag/part_18/368078/pre/500_500sb.jpg',
      price: 2270,
      category: 2,
    },
    {
      id: '4',
      name: 'OLAPLEX BOND INTENSE MOISTURE MASK Маска восстанавливающая увлажняющая для волос No. 8',
      desc: ' OLAPLEX Bond Building, высококонцентрированная восстанавливающая маска придает блеск, гладкость и объем, ',
      image: 'https://static.iledebeaute.ru/files/images/tag/part_19/387646/pre/500_500sb.jpg',
      price: 3290,
      category: 2,
    },
    {
      id: '5',
      name: 'TANGLE TEEZER Крем-спрей для легкого расчесывания волос Everyday Detangling Cream Spray',
      desc: 'Крем-спрей для легкого расчесывания волос Tangle Teezer Everyday Detangling Cream Spray создан для густых, кудрявых и вьющихся волос.',
      image: 'https://static.iledebeaute.ru/files/images/tag/part_18/366392/pre/500_500sb.jpg',
      price: 1450,
      category: 2,
    },
    {
      id: '6',
      name: 'PERCY&REED TURN UP THE VOLUME Шампунь сухой для объёма Создай объём, флакон для путешествий',
      desc: 'Придаёт объём у корней, освежает волосы и продлевает жизнь Вашей укладки.',
      image: 'https://static.iledebeaute.ru/files/images/tag/part_19/382200/pre/500_500sb.jpg',
      price: 670,
      category: 2,
    },
    {
      id: '7',
      name: 'LOVIEN ESSENTIAL Сыворотка Витадексил - профилактика выпадения волос в ампулах',
      desc: 'Применение сыворотки предупреждает выпадение волос. Способствует нормальному росту',
      image: 'https://static.iledebeaute.ru/files/images/tag/part_5/115477/pre/500_500sb.jpg',
      price: 3300,
      category: 2,
    },
    {
      id: '8',
      name: 'NATURA SIBERICA DETOX ORGANICS KAMCHATKA Шампунь для волос Супер Баланс',
      desc: 'Яркое beauty-открытие! Сияющая красота твоих волос вместе с NATURAL SUPER BALANCE SHAMPOO.',
      image: 'https://static.iledebeaute.ru/files/images/tag/part_15/317960/pre/500_500sb.jpg',
      price: 270,
      category: 2,
    },
  ],
  care: [
    {
      id: '9',
      name: 'CLARINS Addition Concentre Eclat Visage Концентрат с эффектом загара для лица',
      desc: 'Уникальное средство, сочетающее простоту использования и безупречный результат. ',
      image: 'https://static.iledebeaute.ru/files/images/tag/part_19/384781/pre/500_500sb.jpg',
      price: 2240,
      category: 3,
    },
    {
      id: '10',
      name: 'CLINIQUE Moisture Surge Интенсивно увлажняющий гель',
      desc: 'Ваш любимый увлажняющий крем-гель стал еще эффективнее. Средство глубоко увлажняет',
      image: 'https://static.iledebeaute.ru/files/images/tag/part_19/384427/pre/500_500sb.jpg',
      price: 850,
      category: 3,
    },
    {
      id: '11',
      name: 'CLARINS Mousse Nettoyante Peau Neuve',
      desc: 'Воздушный пенящийся мусс подходит для любого типа кожи. Формула на основе органических ',
      image: 'https://static.iledebeaute.ru/files/images/tag/part_18/377628/pre/500_500sb.jpg',
      price: 880,
      category: 3,
    },
    {
      id: '12',
      name: 'SHISEIDO Sports Тональный BB-крем SPF50',
      desc: 'Солнцезащитное BB-средство идеально подходит для занятий спортом и активного отдыха под открытым небом.',
      image: 'https://static.iledebeaute.ru/files/images/tag/part_15/316297/pre/500_500sb.jpg',
      price: 2880,
      category: 3,
    },

    {
      id: '13',
      name: 'SHISEIDO WASO Очищающее трио Перезагрузка',
      desc: 'Детокс для кожи и причина для хорошего настроения! ',
      image: 'https://static.iledebeaute.ru/files/images/tag/part_19/384061/pre/500_500sb.jpg',
      price: 2450,
      category: 3,
    },
    {
      id: '14',
      name: 'KENZO KENZOKI HYDRATION FLOW Увлажняющий крем',
      desc: 'Откройте для себя увлажняющий крем ангел-хранитель для комбинированной и жирной кожи. ',
      image: 'https://static.iledebeaute.ru/files/images/tag/part_19/392056/pre/500_500sb.jpg',
      price: 3950,
      category: 3,
    },
    {
      id: '15',
      name: 'ESTEE LAUDER Advanced Night Repair Starter Set Набор',
      desc: 'Незаменимые средства Advanced Night Repair делают мимические и возрастные морщины значительно менее заметными',
      image: 'https://static.iledebeaute.ru/files/images/tag/part_19/395461/pre/500_500sb.jpg',
      price: 4600,
      category: 3,
    },
    {
      id: '16',
      name: 'SHISEIDO WASO SATOCANE Маска-скраб для глубокого очищения пор',
      desc: 'Маска-скраб на основе минеральной глины глубоко очищает поры и эффективно устраняет загрязнения и черные точки, уменьшая видимость пор.',
      image: 'https://static.iledebeaute.ru/files/images/tag/part_19/390979/pre/500_500sb.jpg',
      price: 3150,
      category: 3,
    },
  ],
  makeup: [
    {
      id: '17',
      name: 'YVES SAINT LAURENT COUTURE EYE LINER Жидкая подводка для глаз',
      desc: 'Couture Eyeliner - это первая жидкая подводка, обогащенная тройным комплексом для роста ресниц. Инновационная стойкая формула подводки идеально подходит для осеннего сезона.',
      image: 'https://static.iledebeaute.ru/files/images/tag/part_12/252791/pre/500_500sb.jpg',
      price: 3250,
      category: 1,
    },
    {
      id: '18',
      name: 'ESTEE LAUDER Pure Color Envy Губная помада',
      desc: 'Моделирует форму губ: многогранные частицы пигмента помогают создать яркий образ. Губы приобретают соблазнительную форму и изгиб.',
      image: 'https://static.iledebeaute.ru/files/images/tag/part_16/337324/pre/257_257sb.jpg',
      price: 3120,
      category: 1,
    },
    {
      id: '19',
      name: 'NEW NUDE PALETTE',
      desc: 'Революционные текстуры и оттенки, которые кардинально меняет представление о естественном макияже глаз',
      image: 'https://static.iledebeaute.ru/files/images/tag/part_15/303962/pre/500_500sb.jpg',
      price: 6930,
      category: 1,
    },
    {
      id: '20',
      name: ' GIVENCHY Volume Disturbia & Le Rouge Set',
      desc: ' Набор для макияжа Текстура туши для ресниц Volume Disturbia от Givenchy создает захватывающий изгиб и увеличивет объем на 41%. Формула обогащена витамином Е, который обладает защитными свойствами.',
      image: 'https://static.iledebeaute.ru/files/images/tag/part_19/393925/pre/500_500sb.jpg',
      price: 1670,
      category: 1,
    },
    {
      id: '21',
      name: 'ESTEE LAUDER Double Wear',
      desc: '24 часа стойкости и естественный матовый финиш.',
      image: 'https://static.iledebeaute.ru/files/images/tag/part_15/313126/pre/500_500sb.jpg',
      price: 4370,
      category: 1,
    },
    {
      id: '22',
      name: 'DIOR BACKSTAGE GLOW FACE PALETTE',
      desc: 'Культовая многофункциональная палетка для макияжа. Палетка для сияния лица Dior Backstage это секретное средство визажистов Dior',
      image: 'https://static.iledebeaute.ru/files/images/tag/part_18/366221/pre/500_500sb.jpg',
      price: 4110,
      category: 1,
    },
    {
      id: '23',
      name: 'TOM FORD Fiber Brow Gel Гель для бровей',
      desc: 'Формирует. Окрашивает. Фиксирует. Создает эффект густых, натурально выглядящих бровей;',
      image: 'https://static.iledebeaute.ru/files/images/tag/part_17/353387/pre/500_500sb.jpg',
      price: 3990,
      category: 1,
    },
    {
      id: '24',
      name: 'YVES SAINT LAURENT COUTURE COLOUR CLUTCH PALETTE TUXEDO Палетка теней для век',
      desc: 'Новая палетка теней для век Couture Colour Clutch Palette Tuxedo из коллекции Le Smokey для макияжа глаз от бренда YSL Beauty',
      image: 'https://static.iledebeaute.ru/files/images/tag/part_19/392455/pre/500_500sb.jpg',
      price: 7930,
      category: 1,
    },
  ],
};

const make = data.makeup
const hair = data.hair
const care = data.care

export const allProducts = make.concat(hair, care)